import styles from './TableHead.module.scss';

type Props = {
  /**
   * The content to render within the component.
   * Typically a `TableRow` component.
   */
  children: React.ReactNode;
};

/**
 * The `thead` tag; use to describe column data.
 */
export const TableHead = (props: Props) => {
  return (
    <thead className={styles.tableHead} data-zds>
      {props.children}
    </thead>
  );
};
